import {
  isAureaActiveClient,
  isBfacmActiveClient,
  isBpcActiveClient,
  isBvalorActiveClient,
  isHemeraActiveClient,
  isStinvestActiveClient,
} from '»utils/clientsUtils';

import { AppCardAurea } from './Aurea';
import { AppCardBancoValor } from './BancoValor';
import { AppCardBFACM } from './BFACM';
import { AppCardBPC } from './BPC';
import { AppCardFinantech } from './Finantech';
import { AppCardHemera } from './Hemera';
import { AppCardStandard } from './Standard';

export const AppCard = () => {
  if (isAureaActiveClient) return <AppCardAurea />;

  if (isHemeraActiveClient) return <AppCardHemera />;

  if (isBfacmActiveClient) return <AppCardBFACM />;

  if (isStinvestActiveClient) return <AppCardStandard />;

  if (isBpcActiveClient) return <AppCardBPC />;

  if (isBvalorActiveClient) return <AppCardBancoValor />;

  return <AppCardFinantech />;
};
